var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$route.path!='/course/studyCourse')?_c('nav-bar'):_vm._e(),(_vm.$route.path=='/course')?_c('div',[_c('page-content',{ref:"page_content animate__animated animate__fadeIn"}),_c('bottom-slider')],1):_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }